import { useContext } from "react";
import UserAuthContext from "../contexts/userAuthContext";

const useAuth = () => useContext(UserAuthContext);

export default useAuth;
